import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CdsIconModule } from '@cds/ng-web-components/icon';
import { CdsProgressModule } from '@cds/ng-web-components/progress';

@Component({
  selector: 'app-cd-download-progress',
  templateUrl: './cd-download-progress.component.html',
  styleUrls: ['./cd-download-progress.component.scss'],
  imports: [CdsIconModule, CdsProgressModule],
})
export class CdDownloadProgressComponent implements OnInit {
  @Input() show = false;
  @Output() close1 = new EventEmitter<void>();
  constructor() {}

  ngOnInit() {}

  btnXOnClick() {
    this.close1.emit();
  }
}
